import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { AdminSidebar } from './AdminSidebar';
import { ManagerSidebar } from './ManagerSidebar';
import { Topbar } from './Topbar';
import { Loader2 } from 'lucide-react';
import { ChatWidget } from '@/components/chat/ChatWidget';

export function AdminAppLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin et Managers peuvent accéder à la console admin
  if (user.role !== 'admin' && user.role !== 'manager') {
    return <Navigate to="/" replace />;
  }

  const isManager = user.role === 'manager';

  return (
    <div className="min-h-screen bg-background">
      {isManager ? <ManagerSidebar /> : <AdminSidebar />}
      <div className="lg:pl-64">
        <Topbar />
        <main className="pt-16 p-6">
          <Outlet />
        </main>
      </div>
      <ChatWidget />
    </div>
  );
}
